/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_GalicianInputs */



/**
* | output |
* | --- |
* | "Galician" |
*
* @param {Speechmatics_Target_Language_GalicianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_galician = /** @type {((inputs?: Speechmatics_Target_Language_GalicianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_GalicianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Galicien")
	if (locale === "de") return /** @type {LocalizedString} */ ("galizisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("galiziano")
	if (locale === "ru") return /** @type {LocalizedString} */ ("галисийский")
	if (locale === "es") return /** @type {LocalizedString} */ ("gallego")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加利西亚语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ガリシア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गैलिशियन्")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("galego")
	return /** @type {LocalizedString} */ ("Galician")
});